import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { AuthSendOtpRequestBody, AuthSendOtpResponse } from "./types";

export class AuthSendOtpAPI extends BaseAPI<
  AuthSendOtpRequestBody,
  AuthSendOtpResponse
> {
  protected route = ApiRoutes.auth.send_otp;
  protected method = RequestMethod.POST;
}
